import { render, staticRenderFns } from "./index.vue?vue&type=template&id=fe970ed6&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"
import style0 from "./index.vue?vue&type=style&index=0&id=fe970ed6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TermsHero: require('C:/Users/alinu/Workspace/Machinations-website/wp-nuxt/components/terms/TermsHero.vue').default})
